<template>
  <v-tabs fixed-tabs :v-once="query">
    <v-tab ripple>
      Workflow
    </v-tab>
    <v-tab ripple>
      Status History
    </v-tab>
    <v-tab-item>
      <v-stepper :value="steps" vertical class="policyLifeCycle" v-if="loadNormalWorkFlow">
        <v-stepper-step step="1" v-bind:complete="steps > 1">
          {{claimStatusConst.N}}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div v-if="steps >= 1">
            <template v-if="newDetails">
              <v-subheader>Created By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{newDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(newDetails.statusDate)}}</span>
              </div>
            </template>
            <div>
              <v-icon>mdi-domain</v-icon>
              <span>{{intermediary}}</span>
            </div>
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" v-bind:complete="steps > 2">
          {{claimStatusConst.A}}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div v-if="steps >= 2">
            <template v-if="confirmedDetails">
              <v-subheader>Confirmed By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{confirmedDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(confirmedDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
        <v-stepper-step step="3" v-bind:complete="steps > 3">
          {{claimStatusConst.S}}
        </v-stepper-step>
        <v-stepper-content step="3">
          <div v-if="steps >= 3">
            <template v-if="submittedDetails">
              <v-subheader>Submitted By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{submittedDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(submittedDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
      </v-stepper>
      <v-stepper :value="steps" vertical class="policyLifeCycle" v-else>
        <v-stepper-step step="4" v-bind:complete="true">
          <span>{{currentStatusLabel}}</span>
        </v-stepper-step>
        <v-stepper-content step="4">
          <template v-if="currentStatus === 'V' && voidDetails">
            <v-subheader>Void By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{voidDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(voidDetails.statusDate)}}</span>
            </div>
          </template>
        </v-stepper-content>
      </v-stepper>
    </v-tab-item>
    <v-tab-item>
      <status-history></status-history>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'
import { claimStatus } from '@/const/claims'
import StatusHistory from '../StatusHistory'

export default {
  computed: {
    currentStatus() {
      return this.$store.state.claims.claimDetail.commonInfo.statusCode
    },
    steps() {
      // Claim Life Cycle is as such:
      /*
        1: New
        2: Confirmed
        3: Submitted
      */
      let lifeCycle = 1
      if (this.currentStatus === 'N') {
        lifeCycle = 1
      } else if (this.currentStatus === 'A') {
        lifeCycle = 2
      } else if (this.currentStatus === 'S') {
        lifeCycle = 3
      } else {
        lifeCycle = 4
      }
      return lifeCycle
    },
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    intermediary() {
      return this.claimDetail.commonForm.intermediary + ' - ' + this.claimDetail.commonInfo.intermediaryName
    },
    claimStatusConst() {
      return claimStatus
    },
    loadNormalWorkFlow() {
      // Steps will only be 1 if its Sales Opp or other statuses
      // Once reach this stage, it shouldn't be sales opp anymore
      if (this.steps === 4) {
        return false
      } else {
        return true
      }
    },
    currentStatusLabel() {
      if (claimStatus[this.currentStatus]) {
        return claimStatus[this.currentStatus]
      } else {
        return 'Unknown Status'
      }
    },
    newDetails() {
      return this.getClaimStatusDetail('N')
    },
    confirmedDetails() {
      return this.getClaimStatusDetail('A')
    },
    submittedDetails() {
      return this.getClaimStatusDetail('S')
    },
    closedDetails() {
      return this.getClaimStatusDetail('C')
    },
    voidDetails() {
      return this.getClaimStatusDetail('V')
    },
    cancelDetails() {
      return this.getClaimStatusDetail('X')
    }
  },
  methods: {
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    },
    getClaimStatusDetail(statusCode) {
      return this.$store.getters.getClaimStatusDetail(statusCode)
    }
  },
  components: {
    StatusHistory
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
// Will inherit the css from LifeCycle (as this is the child component)
</style>
